import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { styles } from "../../../assets/MUIStyles/agentStyle";
import TestCard from "./TestCard";

const SectionHeader = ({ title, count, icon }) => (
  <Box
    className="flex-align-center gap-2 mb-3 pb-3"
    sx={{ borderBottom: "2px solid #F5F5F5" }}
  >
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: 2,
        bgcolor: icon === "⟳" ? "#E3F2FD" : "#E8F5E9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography sx={{ fontSize: "1.2rem" }}>{icon}</Typography>
    </Box>
    <Box sx={{ flex: 1 }}>
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, color: "text.primary", fontSize: "1rem" }}
      >
        {title}
      </Typography>
      <Typography
        variant="caption"
        sx={{ color: "text.secondary", fontWeight: 500 }}
      >
        {count} {count === 1 ? "test" : "tests"}
      </Typography>
    </Box>
  </Box>
);

const EmptyState = ({ type }) => (
  <Box className="text-center py-3">
    <Box
      className="flex-xy-center"
      sx={{
        width: 64,
        height: 64,
        borderRadius: "50%",
        bgcolor: type === "ongoing" ? "#E3F2FD" : "#F5F5F5",
        margin: "0 auto 16px",
      }}
    >
      <Typography sx={{ fontSize: "2rem" }}>
        {type === "ongoing" ? "⏱️" : "✅"}
      </Typography>
    </Box>
    <Typography
      variant="body1"
      sx={{ color: "text.secondary", fontWeight: 500, mb: 0.5 }}
    >
      No {type === "ongoing" ? "Ongoing" : "Completed"} Tests
    </Typography>
    <Typography variant="caption" sx={{ color: "text.disabled" }}>
      {type === "ongoing"
        ? "Run agent tests to see results here"
        : "Run ongoing tests to see results here"}
    </Typography>
  </Box>
);

const TestsSection = ({ state, setState, handleLatestStatus }) => {
  const { allTests } = state;
  const completedTests = allTests?.filter(
    (obj) => obj.status === "failed" || obj.status === "success"
  );

  const ongoingTests = allTests?.filter((obj) => !completedTests.includes(obj));

  return (
    <Grid container spacing={3}>
      <Grid
        sx={{
          borderRight: { md: "1px solid #E0E0E0", xs: "none" },
          px: 1,
        }}
        size={{ xs: 12, md: 6 }}
      >
        <SectionHeader
          title="Ongoing Tests"
          count={ongoingTests?.length || 0}
          icon="⟳"
        />
        <Box sx={styles.testBodyContainer}>
          {ongoingTests?.length > 0 ? (
            <Stack spacing={2}>
              {ongoingTests.map((objection) => (
                <TestCard
                  key={objection.object_id}
                  objection={objection}
                  isOngoing
                  state={state}
                  setState={setState}
                  handleLatestStatus={handleLatestStatus}
                />
              ))}
            </Stack>
          ) : (
            <EmptyState type="ongoing" />
          )}
        </Box>
      </Grid>

      <Grid
        sx={{
          pr: 1,
          borderTop: { xs: "2px solid #F5F5F5", md: "none" },
          pt: { xs: 3, md: 0 },
        }}
        size={{ xs: 12, md: 6 }}
      >
        <SectionHeader
          title="Completed Tests"
          count={completedTests?.length || 0}
          icon="✓"
        />
        <Box sx={styles.testBodyContainer}>
          {completedTests?.length > 0 ? (
            <Stack spacing={2}>
              {completedTests.map((objection) => (
                <TestCard
                  key={objection.object_id}
                  objection={objection}
                  state={state}
                  setState={setState}
                  handleLatestStatus={handleLatestStatus}
                />
              ))}
            </Stack>
          ) : (
            <EmptyState type="completed" />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default TestsSection;
